import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./banner.css";
import htmlParser from "html-react-parser";



export default function Banner({ bannerData }) {
  const [navbar, setNavbar] = useState(false);
  const imgCDNURL = process.env.REACT_APP_CDN_URL;
  return (
    <>
      <div className="banner">
        <Container className="banner-container">
          <Row className="banner-row">
            <Col>
              <div>
                <p className="meetleadership">
                {htmlParser(bannerData.eventName)}
                <img src={imgCDNURL + "whitevctor.webp"} className="img-fuild whitevector" alt="vector img"></img>
                </p>
                <p className="industrytext">
                {htmlParser(bannerData.bannerPara)}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
